import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Button, Popover, PopoverHeader, Table } from "reactstrap";

export default function WLTransactionHistory(props) {
  const [uncollapsed, setUncollapsed] = useState([]);
  const [portfolioTxn, setPortfolioTxn] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState([]);
  const [activePopover, setActivePopover] = useState(null);

  const [orderID, setOrderId] = useState()

  useEffect(() => {
    function handleClickOutside(event) {
      if (activePopover && !activePopover.contains(event.target)) {
        setPopoverOpen({});
        setActivePopover(null);
      }
    }

    if (activePopover) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activePopover]);

  const toggle = (key, orderId) => {
    setOrderId(orderId)
    setPopoverOpen((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));

    setActivePopover(popoverOpen[key] ? null : document.getElementById(`Popover-${key}`));
  };

  let fileName = "TransactionTimeline_" + props?.productDetails?.product + "_" + moment().format("DDMMYYYY");
  
  useEffect(() => {
    if (props.transactions && props.transactions.length > 3) {
      let uncollapse = props.transactions.slice (0, 3);
      setUncollapsed([...uncollapse]);
    } else {
      setUncollapsed([...props.transactions]);
    }

    if (props && 
      props?.portfolio &&
      props?.portfolio?.data &&
      props?.portfolio?.data?.txns &&
      props?.portfolio?.data?.txns.length) {
        setPortfolioTxn(props?.portfolio?.data?.txns);
      }
  }, []);

  const showMoreTx = () => {
    setUncollapsed([...props.transactions]);
  }

  const showLessTx = () => {
    let uncollapse = props.transactions.slice (0, 3);
    setUncollapsed([...uncollapse]);
  }

  const getOrderStatus = (status) => {
    if (status === "Order Initiated" || status === "Quote Requested" || status === "Order Placed" || status ==="Order Under Process"
    || status == "Bid pending" || status == "Pending" || status == "Bid placed") {
      return "text-warning";
    }
    if (
      status === "Order Processed" || status == "Bid success" ||
      status === "Payment Received" || status == "Mandate accepted" || status == "Units alloted"
    ) {
      return "payment-received";
    }
    return "text-danger"
  }

  const downloadTxn = (portfolioTxn) => {
    var csvData = [];
    var columns = [
      "PAN",
      "Investment Opportunity Name",
      "Investment Opportunity Category",
      "ISIN",
      "Date of Transaction (DD/MM/YYYY)",
      // "Date of Settlement (DD/MM/YYYY)",
      "Units",
      "Actual Price Per Unit (₹)",
      // "Applicable Price Per Unit (₹)",
      "Bidd Offer Benefit (₹)",
      "Total Investment Amount (₹)",
      "Transaction Type",
      // "Payment Mode",
      // "Payment Status",
      // "Payment ID",
      "Order ID",
      "Interest/Returns Amount (₹)",
      "TDS @ 10%, Applicable on Interest/Returns payout after 1st April 2023",
      "Net Pay"
    ];
    csvData.push(columns);
    if (portfolioTxn && portfolioTxn.length) {
      for (let txn of portfolioTxn) {
        var values = [];
        var coupons = txn?.pastCoupons 
          && txn?.pastCoupons.length 
          ? txn?.pastCoupons 
          : []; 
        let couponSum = 0.0;

        /**PAN */
        values.push(txn && txn?.pan|| "-");
        /**Investment Opportunity Name */
        values.push(props?.productDetails?.productName || "-");
        /**Investment Opportunity Category */
        let productType = props?.productDetails && (props.productDetails.product === "naviptc0" || props.productDetails.product === "naviptc1") ? "PTC" : props?.productDetails?.productType;
        productType = productType && productType.charAt(0).toUpperCase() + productType.slice(1);
        values.push(productType || "-");
        /**ISIN */
        values.push(txn?.trueISIN || "-");
        /**Date of Transaction (DD/MM/YYYY) */
        values.push(
          txn?.txnDateStr ? 
          new moment(new Date(txn.txnDateStr)).format('DD/MM/YYYY') :
          "-"
        );
        /**Date of Settlement (DD/MM/YYYY) */
        // values.push(
        //   txn?.settlementDateStr ? 
        //   new moment(new Date(txn.settlementDateStr)).format('DD/MM/YYYY') :
        //   "-"
        // );
        /**Units */
        values.push(txn?.units || "-");
        /**Actual Price Per Unit (₹) */
        values.push(txn?.unitPrice.toFixed(2) || "-");
        /**Applicable Price Per Unit (₹) */
        // values.push(txn?.userAmount.toFixed(2) || "-");
         /**Bidd Offer Benefit (₹) */
         values.push(txn?.oroAmount || txn?.referralBenefits?.discountForReferal || "-");
        /**Total Investment Amount (₹) */
        let amt = txn?.userAmount.toFixed(2) || 0.0 + txn?.oroAmount.toFixed(2) || 0.0;
        values.push( amt || "-");
        /**Transaction Type */
        values.push(txn?.type || "-");
        /**Payment Mode */
        // values.push(txn?.paymentMode || "-");
        /**Payment Status */
        // values.push(txn?.status || "-");
        /**Payment ID */
        // values.push(txn?.paymentId || "-");
        /**Order ID */
        values.push(txn?.orderId || "-");
        /**Coupon Amount (₹) */
        coupons.map((coupon) => {
          if ( coupon && coupon?.CouponPer1k ) {
            couponSum += coupon?.CouponPer1k;
          }
        });
        couponSum = Number(couponSum *  txn?.units || '0.0').toFixed(2)
        values.push(Number(couponSum) || "-");
        /**TDS @ 10%, Applicable on coupon payout after 1st April 2023 */
        let tds = Number(txn?.tds || "0.0").toFixed(2)
        values.push(Number(tds) || "-");
        /**Net Pay */
        let netPay = Number(txn?.netPay || "0.0").toFixed(2)
        values.push(Number(netPay) || "-");

        csvData.push(values);
      };
    };
    return csvData;
  };

  useEffect(() => {
    if (props?.productDetails?.productType == "ipo") {
      if (props.transactions && props.transactions.length > 3) {
        let uncollapse = props.transactions.slice(0, 3);
        setUncollapsed([...uncollapse]);
        setPopoverOpen(new Array(uncollapse.length).fill(false)); // Initialize with false
      } else {
        setUncollapsed([...props.transactions]);
        setPopoverOpen(new Array(props.transactions.length).fill(false)); // Initialize with false
      }

      if (
        props &&
        props?.portfolio &&
        props?.portfolio?.data &&
        props?.portfolio?.data?.txns &&
        props?.portfolio?.data?.txns.length
      ) {
        setPortfolioTxn(props?.portfolio?.data?.txns);
      }
    }
  }, []);

  return (
    <div className="main-table">
      <div className="inner">
        <p className={props?.isMobile ? "title mb-0" : "title"}>Recent Transactions</p>
        { portfolioTxn && portfolioTxn.length ?
          (window.ReactNativeWebView ? (
            <div
              className="csvBtn font-size-tiny text-secondary mt-3 d-flex"
              onClick={() => {
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    fileName: fileName && fileName,
                    action: "DOWNLOAD_CSV",
                    data: downloadTxn(portfolioTxn),
                  })
                );
              }}
            >
              <i
                className="mdi mdi-download font-size-small"
                style={{ position: "relative", "line-height": "0" }}
              />
              <p className="mt-1">Download Timeline</p>
            </div>
          ) : (
            <CSVLink
              className="csvBtn font-size-tiny text-secondary mt-3 d-flex"
              style={props.isMobile ? {width: "max-content", marginLeft: "auto"} : {}}
              filename={fileName && fileName}
              data={downloadTxn(portfolioTxn)}
            >
              <i
                className="mdi mdi-download font-size-small"
                style={{ position: "relative", "line-height": "0" }}
              />
              <p className="mt-1">Download Timeline</p>
            </CSVLink>
          )) : ""
        }
      </div>
      <div className="wrapper">
        <Table
          striped
          bordered
          className="trans-table"
        >
          <thead className="thead">
            <tr className="trow">
              <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Date - Time
              </th>
              {props?.productDetails?.productType == "ipo" && <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Product Name
              </th>}
              <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Transaction Type
              </th>
              <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Status
              </th>
              <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Amount
              </th>
              <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Units
              </th>
              {props?.productDetails?.productType != "ipo" && <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >
                Transaction Id
              </th>}
              <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
              >RFQ No.</th>
             {props?.productDetails?.productType == "ipo" && props?.disableCancel && <th
                className="text-center bg-secondary text-white font-weight-semi-bold noBorder"
               />}
            </tr>
          </thead>
          <tbody className="tbody">
            {uncollapsed.map((item, key) => (
              <tr className="text-center">
                <td className="noBorder font-weight-semi-bold text-capitalize">
                  {moment(item?.createdAt).format('DD/MM/YYYY')} - {new moment(item?.createdAt).format('h:mm:ss A')}
                </td>
                {item.productType == "ipo" && <td className="noBorder font-weight-semi-bold text-capitalize">
                {props?.series && props?.series.map((i)=> {
                    return i.ISIN == item.ISIN ? i.displayName : ""
                    })}
                </td>}
                <td className="noBorder font-weight-semi-bold text-capitalize">
                  {item.type || "Purchase"}
                </td>
                <td
                  className={
                    "noBorder font-weight-semi-bold text-capitalize " +
                    (getOrderStatus(item.status))
                  }
                >
                  {item?.status == "Quote Ready" ?
                    <a className="text-success" href={`/platform/#/biddeasy-asset/${item.productType}/${item.product}/redeem/${item.orderId}`}><u>{item.status}</u>
                    </a> :
                    item.status}
                </td>
                <td className="noBorder font-weight-semi-bold text-capitalize">
                {item?.status == "Quote Ready" || item.status == "Quote Requested" || item.status == "Order Cancelled" ? "--" : item?.amountBreakup?.ispAmount ? 
                      (item?.amountBreakup?.ispAmount).oroNumber(2, true) 
                      :(item?.amountBreakup?.userAmount).oroNumber(2, true)}
                </td>
                <td className="noBorder font-weight-semi-bold">
                  {item?.productType == "ipo" ? item.amountBreakup.units : item?.amountBreakup.units ? item.amountBreakup.units : "--"}
                </td>
               {item?.productType != "ipo" && <td className="noBorder font-weight-semi-bold">
                  {item?.orderId} 
                </td>}
                <td className="noBorder font-weight-semi-bold">{item?.rfqDetails?.orderNumber ?? "--"}</td>
                {props?.productDetails?.productType == "ipo" && props?.disableCancel && <td className="noBorder font-weight-semi-bold">
                {item?.productType == "ipo" && (item.status == "Bid pending" || item.status == "Bid placed" || item.status == "Bid success") ?  
                  <>
                      <span
                        id={`Popover-${key}`}
                        onClick={() => toggle(key,item.orderId )} 
                        style={{ cursor: "pointer" }}
                        className="mdi mdi-dots-vertical"
                      ></span>
                   
                  <Popover
                    placement="bottom"
                    isOpen={popoverOpen[key]} 
                    target={`Popover-${key}`}
                    toggle={() => toggle(key)}
                  >
                    <PopoverHeader style={{cursor : "pointer"}} onClick={(e)=> props?.toggleThankYou(orderID, e)}>Cancel Bid</PopoverHeader>
                    <PopoverHeader style={{cursor : "pointer"}} onClick={(e)=> props?.getUpdateStatus(orderID, e)}>Refresh Status</PopoverHeader>
                  </Popover>
                  </>
                  : null}
                </td>} 
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      {uncollapsed.length === 3 && props.transactions.length > 3 ? 
        <Button className="btn" onClick={showMoreTx}>View More</Button>
        :
        ''
      }
      {uncollapsed.length > 3 ? 
        <Button className="btn" onClick={showLessTx}>View Less</Button>
        :
        ''
      }
    </div>
  );
}